//Global imports
import React, { ReactNode } from 'react';

interface HintTextProps {
    children: ReactNode;
    marginBottom?: string;
}

const HintText: React.FC<HintTextProps> = ({ children, marginBottom = 0 }) => {
    return (
        <small
            className="text-muted fst-italic fw-light d-block"
            style={{ fontSize: '0.75rem', marginBottom }}
        >
            {children}
        </small>
    );
};

export default HintText;
